// Hinweis + „Berechtigung anfordern…"-Button für die Setup-Screens. Erscheint, solange der Mikrofon-
// (bzw. Kamera-)Zugriff nicht erteilt ist — etwa weil der Browser-Dialog weggeklickt/abgelehnt wurde.
// Ein Klick auf den Button ist eine User-Geste → der Browser zeigt den Dialog erneut (sofern nicht hart
// geblockt; dann hilft der Settings-Hinweis). Speist sich aus useMediaSetup (ready/camReady/requesting/request).
import styles from './PermissionNotice.module.css';

export function PermissionNotice({ ready, camReady, requesting, onRequest }: {
  ready: boolean;
  camReady: boolean;
  requesting: boolean;
  onRequest: () => void;
}) {
  if (ready && camReady) return null;
  const text = !ready
    ? 'Kein Zugriff auf Mikrofon erteilt.'
    : 'Kamera nicht freigegeben (oder keine Kamera vorhanden).';
  return (
    <div className={styles.notice}>
      <div className={styles.text}>
        {text}
        <span className={styles.sub}>Falls kein Dialog erscheint, in den Browser-Einstellungen für diese Seite Mikrofon/Kamera erlauben.</span>
      </div>
      <button className={styles.btn} disabled={requesting} onClick={onRequest}>
        {requesting
          ? <><span className={styles.spinner} aria-hidden="true" />Wird angefordert, bitte warten…</>
          : 'Berechtigung anfordern…'}
      </button>
    </div>
  );
}
